// components/SuggestionsMessage.tsx
import React from 'react';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

interface SuggestionsMessageProps {
  suggestions: string[];
  handleSubmitWrapper: (event: any, promptData?: string) => void;
}

const SuggestionsMessage: React.FC<SuggestionsMessageProps> = ({
  suggestions,
  handleSubmitWrapper,
}) => {
  return (
    <div className="chat-message suggestion-message">
      <h4>Suggestions:</h4>
      <ul>
        {Array.isArray(suggestions) &&
          suggestions.map((suggestion, index) => (
            <li
              className="suggestion-item"
              key={index}
              onClick={() => handleSubmitWrapper(null, suggestion)}
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span>{suggestion}</span>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SuggestionsMessage;
